// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'
import config from '@src/configs/themeConfig'

// const baseUrl = 'http://localhost:3000'
const baseUrl = config.app.baseUrl
const { jwt } = useJwt({
    loginEndpoint: `${baseUrl}/auth/login`,
    registerEndpoint: `${baseUrl}/auth/register`,
    refreshEndpoint: `${baseUrl}/auth/refresh-tokens`,
    logoutEndpoint: `${baseUrl}/auth/logout`,

    // ** This will be prefixed in authorization header with token
    // ? e.g. Authorization: Bearer <token>
    tokenType: 'Bearer',

    // ** Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: 'accessToken',
    storageRefreshTokenKeyName: 'refreshToken'
})

export default jwt
